/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdvertisementsSettings} from '../models/AdvertisementsSettings';
import type {Error} from '../models/Error';
import type {FileData} from '../models/FileData';
import type {SettingsType} from '../models/SettingsType';

export interface GetAdvertisementImage$Request {
    conferenceId: number;
    settingsType: SettingsType;
}

export interface GetAdvertisementImage$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdvertisementImageRequest = createAction<PayloadData<void, GetAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_IMAGE__REQUEST');
export const getAdvertisementImageSuccess = createAction<PayloadData<FileData, GetAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_IMAGE__SUCCESS');
export const getAdvertisementImageFailure = createAction<PayloadData<Error, GetAdvertisementImage$Request, true>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_IMAGE__FAILURE');

export const getAdvertisementImageActions = [
    getAdvertisementImageRequest,
    getAdvertisementImageSuccess,
    getAdvertisementImageFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdvertisementImage = (meta: GetAdvertisementImage$Request, config?: GetAdvertisementImage$Config) => {
    return {
        CALL_API: {
            types: getAdvertisementImageActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAdvertisementSettings$Request {
    conferenceId: number;
    settingsType: SettingsType;
}

export interface GetAdvertisementSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdvertisementSettingsRequest = createAction<PayloadData<void, GetAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_SETTINGS__REQUEST');
export const getAdvertisementSettingsSuccess = createAction<PayloadData<AdvertisementsSettings, GetAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_SETTINGS__SUCCESS');
export const getAdvertisementSettingsFailure = createAction<PayloadData<Error, GetAdvertisementSettings$Request, true>>('CONFERENCE_ADVERTISEMENT__GET_ADVERTISEMENT_SETTINGS__FAILURE');

export const getAdvertisementSettingsActions = [
    getAdvertisementSettingsRequest,
    getAdvertisementSettingsSuccess,
    getAdvertisementSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType The settings type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdvertisementSettings = (meta: GetAdvertisementSettings$Request, config?: GetAdvertisementSettings$Config) => {
    return {
        CALL_API: {
            types: getAdvertisementSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveAdvertisementImage$Request {
    conferenceId: number;
    settingsType: SettingsType;
}

export interface RemoveAdvertisementImage$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeAdvertisementImageRequest = createAction<PayloadData<void, RemoveAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_IMAGE__REQUEST');
export const removeAdvertisementImageSuccess = createAction<PayloadData<void, RemoveAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_IMAGE__SUCCESS');
export const removeAdvertisementImageFailure = createAction<PayloadData<Error, RemoveAdvertisementImage$Request, true>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_IMAGE__FAILURE');

export const removeAdvertisementImageActions = [
    removeAdvertisementImageRequest,
    removeAdvertisementImageSuccess,
    removeAdvertisementImageFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType The settings type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeAdvertisementImage = (meta: RemoveAdvertisementImage$Request, config?: RemoveAdvertisementImage$Config) => {
    return {
        CALL_API: {
            types: removeAdvertisementImageActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveAdvertisementSettings$Request {
    conferenceId: number;
    settingsType: SettingsType;
}

export interface RemoveAdvertisementSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeAdvertisementSettingsRequest = createAction<PayloadData<void, RemoveAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_SETTINGS__REQUEST');
export const removeAdvertisementSettingsSuccess = createAction<PayloadData<void, RemoveAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_SETTINGS__SUCCESS');
export const removeAdvertisementSettingsFailure = createAction<PayloadData<Error, RemoveAdvertisementSettings$Request, true>>('CONFERENCE_ADVERTISEMENT__REMOVE_ADVERTISEMENT_SETTINGS__FAILURE');

export const removeAdvertisementSettingsActions = [
    removeAdvertisementSettingsRequest,
    removeAdvertisementSettingsSuccess,
    removeAdvertisementSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType The settings type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeAdvertisementSettings = (meta: RemoveAdvertisementSettings$Request, config?: RemoveAdvertisementSettings$Config) => {
    return {
        CALL_API: {
            types: removeAdvertisementSettingsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAdvertisementImage$Request {
    conferenceId: number;
    settingsType: SettingsType;
    multipartFile?: File | File[];
}

export interface UpdateAdvertisementImage$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const updateAdvertisementImageRequest = createAction<PayloadData<void, UpdateAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_IMAGE__REQUEST');
export const updateAdvertisementImageSuccess = createAction<PayloadData<void, UpdateAdvertisementImage$Request>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_IMAGE__SUCCESS');
export const updateAdvertisementImageFailure = createAction<PayloadData<Error, UpdateAdvertisementImage$Request, true>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_IMAGE__FAILURE');

export const updateAdvertisementImageActions = [
    updateAdvertisementImageRequest,
    updateAdvertisementImageSuccess,
    updateAdvertisementImageFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType
 * @param {any} [meta.multipartFile]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const updateAdvertisementImage = (meta: UpdateAdvertisementImage$Request, config?: UpdateAdvertisementImage$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        multipartFile: meta.multipartFile,
    };
    return {
        UPLOAD_FILE: {
            types: updateAdvertisementImageActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAdvertisementSettings$Request {
    conferenceId: number;
    settingsType: SettingsType;
    advertisementsSettings: AdvertisementsSettings;
}

export interface UpdateAdvertisementSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAdvertisementSettingsRequest = createAction<PayloadData<void, UpdateAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_SETTINGS__REQUEST');
export const updateAdvertisementSettingsSuccess = createAction<PayloadData<void, UpdateAdvertisementSettings$Request>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_SETTINGS__SUCCESS');
export const updateAdvertisementSettingsFailure = createAction<PayloadData<Error, UpdateAdvertisementSettings$Request, true>>('CONFERENCE_ADVERTISEMENT__UPDATE_ADVERTISEMENT_SETTINGS__FAILURE');

export const updateAdvertisementSettingsActions = [
    updateAdvertisementSettingsRequest,
    updateAdvertisementSettingsSuccess,
    updateAdvertisementSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType
 * @param {AdvertisementsSettings} meta.advertisementsSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAdvertisementSettings = (meta: UpdateAdvertisementSettings$Request, config?: UpdateAdvertisementSettings$Config) => {
    return {
        CALL_API: {
            types: updateAdvertisementSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/${meta.settingsType}/settings`,
            TRANSPORT_REQUEST_BODY: meta.advertisementsSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

